import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { PopupButton } from "react-calendly";
// import TopHeader from "../../components/HomeOne/TopHeader";

const Navbar = () => {
    // Add active class
    const [currentPath, setCurrentPath] = useState("");
    const location = useLocation();
    const router = location.pathname;

    const [menu, setMenu] = React.useState(true);
    const toggleNavbar = () => {
        setMenu(!menu);
    };

    useEffect(() => {
        setCurrentPath(router);
        window.scrollTo(0, 0);
        setMenu(true);
    }, [router]);

    React.useEffect(() => {
        let elementId = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId.classList.add("is-sticky");
            } else {
                elementId.classList.remove("is-sticky");
            }
        });
    });

    const classOne = menu
        ? "collapse navbar-collapse mean-menu"
        : "collapse navbar-collapse show";
    const classTwo = menu
        ? "navbar-toggler navbar-toggler-right collapsed"
        : "navbar-toggler navbar-toggler-right";

    // Search Modal
    // const [isActiveSearchModal, setActiveSearchModal] = useState("false");
    // const handleToggleSearchModal = () => {
    //     setActiveSearchModal(!isActiveSearchModal);
    // };

    return (
        <>
            {/* {currentPath === "/" && <TopHeader />} */}
            <div
                id="navbar"
                className={
                    currentPath === "/"
                        ? "navbar-area"
                        : "navbar-area navbar-area-with-position-relative"
                }
            >
                <div className="main-nav">
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-md navbar-light">
                            <Link to="/" className="navbar-brand">
                                <img src="/images/white-logo.webp" alt="logo" />
                            </Link>

                            <button
                                onClick={toggleNavbar}
                                className={classTwo}
                                type="button"
                                data-toggle="collapse"
                                data-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="icon-bar top-bar"></span>
                                <span className="icon-bar middle-bar"></span>
                                <span className="icon-bar bottom-bar"></span>
                            </button>

                            <div
                                className={classOne}
                                id="navbarSupportedContent"
                            >
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <Link
                                            to="#"
                                            className="nav-link"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            Company{" "}
                                            <i className="fas fa-chevron-down"></i>
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    to="/about"
                                                    className={`nav-link ${currentPath ===
                                                        "/about" && "active"
                                                        }`}
                                                >
                                                    About Us
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    to="/team"
                                                    className={`nav-link ${currentPath ===
                                                        "/team" && "active"
                                                        }`}
                                                >
                                                    Our Team
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    to="/career"
                                                    className={`nav-link ${currentPath ===
                                                        "/career" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Join Us
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    to="/feedback"
                                                    className={`nav-link ${currentPath ===
                                                        "/feedback" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Feedback
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    to="/partner"
                                                    className={`nav-link ${currentPath ===
                                                        "/partner" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Partner
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    to="/faq"
                                                    className={`nav-link ${currentPath ===
                                                        "/faq" && "active"
                                                        }`}
                                                >
                                                    Faq
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            to="/services"
                                            className={`nav-link ${currentPath === "/services" &&
                                                "active"
                                                }`}
                                        >
                                            Services{" "}
                                            <i className="fas fa-chevron-down"></i>
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    to="/services/mobile-app-development"
                                                    className={`nav-link ${currentPath ===
                                                        "/services/mobile-app-development" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Mobile App Development{" "}
                                                    <i className="fas fa-chevron-right"></i>
                                                </Link>
                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/mobile-app-development/flutter"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/mobile-app-development/flutter" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Flutter App
                                                            Development
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/mobile-app-development/android"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/mobile-app-development/android" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Android App
                                                            Development
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/mobile-app-development/ios"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/mobile-app-development/ios" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            iOS App Development
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/mobile-app-development/react-native"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/mobile-app-development/react-native" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            React Native App
                                                            Development
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    to="/services/web-development"
                                                    className={`nav-link ${currentPath ===
                                                        "/services/web-development" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Web Development{" "}
                                                    <i className="fas fa-chevron-right"></i>
                                                </Link>
                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/node"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/node" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Node js
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/react"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/react" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            React js
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/angular"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/angular" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Angular js
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/php"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/php" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            PHP
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/python"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/python" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Python
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/ai-ml"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/ai-ml" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            AI ML
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    to="/services/cms-ecommerce"
                                                    className={`nav-link ${currentPath ===
                                                        "/services/cms-ecommerce" &&
                                                        "active"
                                                        }`}
                                                >
                                                    CMS{" "}
                                                    <i className="fas fa-chevron-right"></i>
                                                </Link>
                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/web-development/shopify"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/shopify" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Shopify
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/cms/wordpress"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-development/node" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Wordpress
                                                        </Link>
                                                    </li>

                                                </ul>
                                            </li>
                                            <li className="nav-item">
                                                <Link

                                                    to="#"
                                                    className="nav-link"
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    Maintenance & Support{" "}
                                                    <i className="fas fa-chevron-right"></i>
                                                </Link>
                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/website-maintenance"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/web-maintenance" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            WebSite Maintenance
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link
                                                            to="/services/mobile-app-development"
                                                            className={`nav-link ${currentPath ===
                                                                "/services/mobile-app-development" &&
                                                                "active"
                                                                }`}
                                                        >
                                                            Mobile App Maintenance
                                                        </Link>
                                                    </li>

                                                </ul>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/case-study">
                                            Case Study{" "}
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            to="#"
                                            className="nav-link"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            Industry{" "}
                                            <i className="fas fa-chevron-down"></i>
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    to="/education"
                                                    className={`nav-link ${currentPath ===
                                                        "/education" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Education{" "}
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    to="/healthcare"
                                                    className={`nav-link ${currentPath ===
                                                        "/healthcare" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Healthcare{" "}
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    to="/ecommerce-retail"
                                                    className={`nav-link ${currentPath ===
                                                        "/ecommerce-retail" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Ecommerce & Retail{" "}
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    to="/banking-finance"
                                                    className={`nav-link ${currentPath ===
                                                        "/banking-finance" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Banking, Finance & Insurance{" "}
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    to="/traveling-transportation"
                                                    className={`nav-link ${currentPath ===
                                                        "/traveling-transportation" &&
                                                        "active"
                                                        }`}
                                                >
                                                    Traveling and Transportation{" "}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            to="/contact"
                                            className={`nav-link ${currentPath === "/contact" &&
                                                "active"
                                                }`}
                                        >
                                            Contact
                                        </Link>
                                    </li>

                                    {/* <li className="nav-item">
                                        <Link
                                            to="/blog"
                                            className={`nav-link ${
                                                currentPath === "/blog" &&
                                                "active"
                                            }`}
                                        >
                                            Blog
                                        </Link>
                                    </li> */}
                                </ul>

                                {/* others-options */}
                                <div className="others-options">
                                    <PopupButton
                                        url="https://calendly.com/etherealsoftechindia"
                                        className="btn btn-primary"
                                        rootElement={document.getElementById(
                                            "root"
                                        )}
                                        text="Book a call"
                                    />
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;
